/* eslint-disable import/prefer-default-export */
import { createSelector } from 'reselect';

const selectActivityType = (state) => state.activityTypes;

export const selectActivityTypeList = createSelector(
  selectActivityType,
  (activityTypeState) => {
    return {
      list: activityTypeState.activityTypeList,
      loading: activityTypeState.isLoading,
    };
  }
);
export const selectActivityTypeLookup = createSelector(
  selectActivityType,
  (activityTypeState) => {
    return {
      lookup: activityTypeState.activityTypesLookup,
      loading: activityTypeState.isLookupLoading,
    };
  }
);

export const selectActivityTypes = createSelector(
  selectActivityType,
  (activityTypeState) => {
    return Object.values(activityTypeState?.activityTypesLookup || {}).sort(
      ({ displayOrder }) => displayOrder
    );
  }
);
